import React, { useState, useEffect } from "react";
import Header from "../../context/Header";
import { Card, Button, Form } from "react-bootstrap";
import app from "../../context/base.js";
import BootstrapTable from "react-bootstrap-table-next";
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import { useHistory } from "react-router-dom";

const AdminViewAllEmployer = ({ component: RouteComponent, ...rest }) => {
  const history = useHistory();
  const [employers, setEmployers] = useState([]);

  const columns = [
    {
      dataField: "employerName",
      text: "Employer Name",
      filter: textFilter(),
    },
    {
      dataField: "mainContact",
      text: "Main Contact",
      filter: textFilter(),
    },
    {
      dataField: "email",
      text: "Employer Email",
      filter: textFilter(),
    },
  ];

  useEffect(() => {
    console.log("*");
    var list = [];
    app
      .firestore()
      .collection("users")
      .where("type", "==", "Employer")
      .get()
      .then((snapshot) => {
        var i = 1;
        snapshot.forEach((doc) => {
          var data = doc.data();
          data.id = doc.id;
          data.num = i++;
          list.push(data);
        });
        setEmployers(list);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);
  /*
  const selectRow = {
    mode: "radio",
    onSelect: (row, isSelect, rowIndex, e) => {
      if (isSelect) {
        console.log(row);
        setSelectedTest(row);
      } else {
        setSelectedTest({});
      }
    },
  };*/

  async function updateSpecificResults(row) {
    history.push({
      pathname: "/a-admin-unauth-results-update",
      state: { detail: row },
    });
  }
  /*
  async function updateResults() {
    if (isEmpty(selectedTest)) {
      alert("No Test Selected");
      return;
    }

    history.push({
      pathname: "/a-admin-unauth-results-update",
      state: { detail: selectedTest },
    });
  }*/

  return (
    <article>
      <Header />
      <Card>
        <Card.Body>
          <Card.Title>Completed Tests ({ employers.length })</Card.Title>

          <Form>
            <BootstrapTable
              keyField="id"
              //selectRow={selectRow}
              data={employers}
              columns={columns}
              filter={filterFactory()}
              hover
            />
          </Form>
          <Card.Text></Card.Text>
        </Card.Body>
      </Card>
    </article>
  );
};

export default AdminViewAllEmployer;
